import {
  IconGithub,
  theme
} from '@contrast-security-inc/design-system-foundations'
import { Stack } from '@contrast-security-inc/design-system-layouts'
import { Card } from '@contrast-security-inc/design-system-surfaces'
import { Text } from '@contrast-security-inc/design-system-typography'
import { css } from '@emotion/css'
import React from 'react'
import { SCMType } from '../../api/queries/onboarding-service/onboarding-service'

const cardStyles = css`
  width: 240px;
  height: 175px;
  display: flex;
  flex-direction: column;
  align-items: center;
  vertical-align: middle;
  cursor: pointer;
  border-radius: 8px;
  border: 4px solid ${theme.color.transparent};
  :hover,
  :focus-visible {
    border: 4px solid ${theme.color.turquoise70};
    outline: unset;
  }
`

// Unfortunately these icons have different view boxes than the skeletor github one
const bitbucketCardStyles = css`
  margin-top: -21px;
`
// Unfortunately these icons have different view boxes than the skeletor github one
const gitlabCardStyles = css`
  margin-top: -16px;
`

export interface SCMOptionProps {
  onClick: (type: SCMType) => void
  className?: string
  scmType: SCMType
}

export const SCMOption = ({ onClick, scmType }: SCMOptionProps) => {
  return (
    <Card
      className={cardStyles}
      // @ts-ignore
      onClick={() => onClick(scmType)}
      tabIndex={0}
      role="link"
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          onClick(scmType)
        }
      }}
    >
      {scmType === SCMType.BITBUCKET && (
        <Stack
          flexDirection="column"
          spacing="8px"
          alignItems="center"
          className={bitbucketCardStyles}
        >
          <img src="images/logos/bitbucket-color.svg" width="100" />
          <Text color="neutral100" font="body">
            Bitbucket
          </Text>
        </Stack>
      )}
      {scmType === SCMType.GITHUB && (
        <Stack flexDirection="column" spacing="24px" alignItems="center">
          <IconGithub color="black" size="lg" />
          <Text color="neutral100" font="body">
            GitHub
          </Text>
        </Stack>
      )}
      {scmType === SCMType.GITLAB && (
        <Stack
          flexDirection="column"
          spacing="4px"
          alignItems="center"
          className={gitlabCardStyles}
        >
          <img src="images/logos/gitlab-color.svg" width="100" />
          <Text color="neutral100" font="body">
            GitLab
          </Text>
        </Stack>
      )}
    </Card>
  )
}
